<template lang="html">

  <div class="custom-font">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/communication')" style="cursor: pointer">Comunicación</li>
        <li class="breadcrumb-item active" aria-current="page">Retroalimentación</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <md-card>
            <md-card-header>
              <md-card-header-text>
                <div class="row">
                  <div class="col-md-9">
                    <div class="md-title">Retroalimentación</div>
                  </div>
                  <div class="col-md-3">
                    <!-- <md-card>
                      <md-card-header> -->
                        <div class="md-title" style="font-size: 21px;">Promedio
                          <span :style="'float: right;color: '+getColor(average)" v-if="average != null">{{formatPrice(average,2)}}</span>
                          <span style="float: right;" v-else>--</span>
                        </div>
                      <!-- </md-card-header>
                    </md-card> -->
                  </div>
                </div>

              </md-card-header-text>
            </md-card-header>
            <md-card-content>
              <div class="row">
                <!-- KPIS -->
                <div class="col-md-3">
                  <md-card>
                    <md-card-header>
                      <div class="md-title" style="font-size: 21px;">Inversionistas
                        <span :style="'float: right;color: '+getColor(investors)" v-if="investors != null">{{formatPrice(investors,2)}}</span>
                        <span style="float: right;" v-else>--</span>
                      </div>
                    </md-card-header>
                  </md-card>
                </div>
                <div class="col-md-3">
                  <md-card>
                    <md-card-header>
                      <div class="md-title" style="font-size: 21px;">Solicitantes
                        <span :style="'float: right;color: '+getColor(applicants)" v-if="applicants != null">{{formatPrice(applicants,2)}}</span>
                        <span style="float: right;" v-else>--</span>
                      </div>
                    </md-card-header>
                  </md-card>
                </div>
                <div class="col-md-3">
                  <md-card>
                    <md-card-header>
                      <div class="md-title" style="font-size: 21px;">Proveedores
                        <span :style="'float: right;color: '+getColor(suppliers)" v-if="suppliers != null">{{formatPrice(suppliers,2)}}</span>
                        <span style="float: right;" v-else>--</span>
                      </div>
                    </md-card-header>
                  </md-card>
                </div>
                <div class="col-md-3">
                  <md-card>
                    <md-card-header>
                      <div class="md-title" style="font-size: 21px;">Portal
                        <span :style="'float: right;color: '+getColor(portal)" v-if="portal != null">{{formatPrice(portal,2)}}</span>
                        <span style="float: right;" v-else>--</span>
                      </div>
                    </md-card-header>
                  </md-card>
                </div>
                <!-- FIN KPIS -->
              </div>
              <vs-divider></vs-divider>
              <br>
              <div class="row">
                <div class="col-md-12">
                  <md-card>
                    <md-card-header>
                      <div class="md-title">Filtros</div>
                    </md-card-header>
                    <md-card-content>
                      <div class="row">
                        <div class="col-md-3">
                          <md-field>
                            <label for="feedback_types">Tipo de FeedBack</label>
                            <md-select v-model="selected_feedback_types" name="feedback_types" id="feedback_types" multiple>
                              <md-option value="general_feedback">Feedback General</md-option>
                              <md-option value="feature_request">Solicitud de Funcionalidad</md-option>
                              <md-option value="service_issue">Problema de Servicio</md-option>
                            </md-select>
                          </md-field>
                        </div>
                        <div class="col-md-3">
                          <md-field>
                            <label for="apps">Aplicación</label>
                            <md-select v-model="selected_apps" name="apps" id="apps" multiple>
                              <md-option value="suppliers">Proveedores</md-option>
                              <md-option value="investors">Inversionistas</md-option>
                              <md-option value="applicants">Solicitantes</md-option>
                              <md-option value="portal">Portal</md-option>
                            </md-select>
                          </md-field>
                        </div>
                        <div class="col-md-2">
                          <md-datepicker v-model="from" md-immediately>
                            <label>Fecha inicio: </label>
                          </md-datepicker>
                        </div>
                        <div class="col-md-2">
                          <md-datepicker v-model="to" md-immediately>
                            <label>Fecha Fin: </label>
                          </md-datepicker>
                        </div>
                        <div class="col-md-2">
                          <md-progress-spinner v-if="loading" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"/>
                          <md-button v-else class="md-raised md-primary" @click="getFeedbacks()">
                            Filtrar
                          </md-button>
                        </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
              <vs-divider></vs-divider>
              <div class="row">
                <!-- TABS -->
                <div class="col-md-12">
                  <vs-tabs>
                     <!-- Nuevos -->
                    <vs-tab label="Nuevos" icon="fiber_new">
                      <md-card>
                        <md-card-content class="custom-font">
                          <vs-table maxHeight="1000" class="custom-font" :data="feedbacks" stripe noDataText="No hay datos disponibles">                              
                            <template slot="thead">
                              <vs-th>ID</vs-th>
                              <vs-th>UID</vs-th>
                              <vs-th>Tipo de FeedBack</vs-th>
                              <vs-th>Aplicación</vs-th>
                              <vs-th>URL</vs-th>
                              <vs-th>Comentario</vs-th>
                              <vs-th>NPS</vs-th>
                              <vs-th>Fecha</vs-th>
                              <vs-th>ACCIONES</vs-th>
                            </template>
                            <template slot-scope="{data}">
                              <vs-tr v-if="tr.status == null" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].id">
                                  {{ tr.id }}
                                </vs-td>
                                <vs-td :data="data[indextr].user_id">
                                  {{ tr.user_id }}
                                </vs-td>
                                <vs-td :data="data[indextr].feedback_type">
                                  {{ getText(tr.feedback_type) }}
                                </vs-td>
                                <vs-td :data="data[indextr].app">
                                  {{ getText(tr.app) }}
                                </vs-td>
                                <vs-td :data="data[indextr].url">
                                  {{ tr.url }}
                                </vs-td>
                                <vs-td :data="data[indextr].feedback">
                                  {{ tr.feedback }}
                                </vs-td>
                                <vs-td :data="data[indextr].nps">
                                  {{ tr.nps }}
                                </vs-td>
                                <vs-td :data="data[indextr].created_at">
                                  {{ tr.created_at | human_date}}
                                </vs-td>
                                <vs-td>
                                  <feather-icon @click="openEmailPopUp(true, tr)" icon="MailIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="mr-3"  />
                                  <feather-icon @click="openActionsPopUp(tr)" icon="CheckSquareIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="ml-3"  />
                                </vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </md-card-content>
                      </md-card>
                    </vs-tab>
                    <!-- Nuevos -->
                   

                    <!-- ATENDIDOS CON ACCIÓN TAB 2 -->
                    <vs-tab label="Abiertos" icon="feedback">
                      <md-card>
                        <md-card-content class="custom-font">
                          <vs-table class="custom-font" :data="feedbacks" stripe noDataText="No hay datos disponibles">                              
                            <template slot="thead">
                              <vs-th>ID</vs-th>
                              <vs-th>UID</vs-th>
                              <vs-th>Tipo de FeedBack</vs-th>
                              <vs-th>Aplicación</vs-th>
                              <vs-th>URL</vs-th>
                              <vs-th>Comentario</vs-th>
                              <vs-th>NPS</vs-th>
                              <vs-th>Fecha</vs-th>
                              <vs-th>ACCIONES</vs-th>
                            </template>
                            <template slot-scope="{data}">
                              <vs-tr v-if="tr.status == 2" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].id">
                                  {{ tr.id }}
                                </vs-td>
                                <vs-td :data="data[indextr].user_id">
                                  {{ tr.user_id }}
                                </vs-td>
                                <vs-td :data="data[indextr].feedback_type">
                                  {{ getText(tr.feedback_type) }}
                                </vs-td>
                                <vs-td :data="data[indextr].app">
                                  {{ getText(tr.app) }}
                                </vs-td>
                                <vs-td :data="data[indextr].url">
                                  {{ tr.url }}
                                </vs-td>
                                <vs-td :data="data[indextr].feedback">
                                  {{ tr.feedback }}
                                </vs-td>
                                <vs-td :data="data[indextr].nps">
                                  {{ tr.nps }}
                                </vs-td>
                                <vs-td :data="data[indextr].created_at">
                                  {{ tr.created_at | human_date}}
                                </vs-td>
                                <vs-td>
                                  <feather-icon v-if="tr.email_response_by != null" @click="openEmailPopUp(false, tr)" icon="MailIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="mr-3"  />
                                  <feather-icon  @click="openActionsPopUp(tr)" icon="CheckSquareIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="mr-3"  />
                                </vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </md-card-content>
                      </md-card>
                    </vs-tab>
                    <!-- ATENDIDOS CON ACCIÓN TAB 2 -->

                    <!-- ATENDIDOS SIN ACCIÓN TAB 3 -->
                    <vs-tab label="Cerrados" icon="chat_bubble_outline">
                      <md-card>
                        <md-card-content class="custom-font">
                          <vs-table class="custom-font" :data="feedbacks" stripe noDataText="No hay datos disponibles">                              
                            <template slot="thead">
                              <vs-th>ID</vs-th>
                              <vs-th>UID</vs-th>
                              <vs-th>Tipo de FeedBack</vs-th>
                              <vs-th>Aplicación</vs-th>
                              <vs-th>URL</vs-th>
                              <vs-th>Comentario</vs-th>
                              <vs-th>NPS</vs-th>
                              <vs-th>Fecha</vs-th>
                              <vs-th>ACCIONES</vs-th>
                            </template>
                            <template slot-scope="{data}">
                              <vs-tr v-if="tr.status == 1" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].id">
                                  {{ tr.id }}
                                </vs-td>
                                <vs-td :data="data[indextr].user_id">
                                  {{ tr.user_id }}
                                </vs-td>
                                <vs-td :data="data[indextr].feedback_type">
                                  {{ getText(tr.feedback_type) }}
                                </vs-td>
                                <vs-td :data="data[indextr].app">
                                  {{ getText(tr.app) }}
                                </vs-td>
                                <vs-td :data="data[indextr].url">
                                  {{ tr.url }}
                                </vs-td>
                                <vs-td :data="data[indextr].feedback">
                                  {{ tr.feedback }}
                                </vs-td>
                                <vs-td :data="data[indextr].nps">
                                  {{ tr.nps }}
                                </vs-td>
                                <vs-td :data="data[indextr].created_at">
                                  {{ tr.created_at | human_date}}
                                </vs-td>
                                <vs-td>
                                  <feather-icon v-if="tr.email_response_by != null" @click="openEmailPopUp(false, tr)" icon="MailIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="mr-3"  />
                                  <feather-icon  @click="openActionsPopUp(tr)" icon="CheckSquareIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="mr-3"  />
                                </vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </md-card-content>
                      </md-card>
                    </vs-tab>
                    <!-- ATENDIDOS SIN ACCIÓN TAB 3 -->
                  </vs-tabs>
                </div>
                <!-- TABS -->
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <!-- POP UP EMAIL -->
      <vs-popup classContent="popup-example"  title="Correo a usuario" :active.sync="emailPopUp" @close="handleOnClose()">
        <vs-alert icon-pack="feather" icon="icon-info" color="warning" active="true" style="height: auto !important;">
          {{ !isEdit || email != null ? `Correo de atención enviado al usuario ${uid}.` : `Envía un correo de atención al usuario ${ uid } para dar seguimiento a su comentario.`  }}
        </vs-alert>
        <br />
        <div v-if="!isEdit || email != null">
          <p>Enviado por: <span> {{ email }}</span></p>
          <p>Fecha: <span> {{ emailDate | human_date }}</span></p>
        </div>
        <br />
        <vs-textarea 
          v-model="comment" 
          label="Cuerpo del correo"
          :disabled="!isEdit || email != null"
        />
        <vs-button :disabled="!isEdit || email != null" @click="sendEmail()" style="float: right;" color="primary" type="filled">Enviar</vs-button>
      </vs-popup>
      <!-- POP UP EMAIL -->

      <!-- POP UP ACTION -->
      <vs-popup  title="Resolución de comentario" :active.sync="actionPopUp" @close="handleOnClose()">
        <vs-alert icon-pack="feather" icon="icon-info" color="warning" active="true" style="height: auto !important;">
            Recuerda que debes marcar los comentarios como <strong>Cerrado</strong> cuando no necesite más nuestra atención. Marcalo como <strong>Abierto</strong> 
            cuando vayamos a darle atención posterior a través de una nueva funcionalidad.
          </vs-alert>
          <br/>

        <div class="vx-row">
          <div :class="colClass" v-for="result in options1" :key="result.value">
              <rg-radio class="w-full" groupName="result" :label="result.label" :value="result.value" v-model.lazy="feedbackStatus" />
          </div>
          <div class="vx-col w-full">
            
              <!-- <vx-select class="w-full mb-5" 
                label="Seleccione una acción" 
                v-model.lazy="feedbackStatus"
                name="feedbackStatus"
                v-validate="'required'"
                placeholder="Seleccione una opción" >
                <vx-select-item v-if="item.value != currentStatus" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in options1" class="w-full" />
              </vx-select> -->
          </div>
        </div>
          
        <vs-button :disabled="feedbackStatus == null" @click="updateFeedbackStatus()" style="float: right;" color="primary" type="filled">Enviar</vs-button>
      </vs-popup>
      <!-- POP UP ACTION -->
    </div>
  </div>

</template>

<script lang="js">
  import * as moment from "moment";
  import RgRadio from "@components/misc/RgRadio.vue";

  export default  {
    name: 'feedback',
    filters: {
      human_date(date) {
        return date == null ? '' : moment(date).lang("es").format("DD MMM YYYY");
      }
    },
    components: {
      RgRadio
    },
    mounted() {
        this.getFeedbacks();
    },
    data() {
      return {
        feedbacks: [],
        selected_feedback_types: ['general_feedback', 'feature_request', 'service_issue'],
        selected_apps: ['suppliers', 'investors', 'applicants', 'portal'],
        from: null,
        to: null,
        loading: false,
        suppliers: 0,
        investors: 0,
        applicants: 0,
        portal: 0,
        average: 0

        , emailPopUp:false
        , actionPopUp:false
        , comment: ""
        , feedbackId: null
        , uid: null
        , email: ""
        , emailDate: ""
        , isEdit: false
        , feedbackStatus: null
        , currentStatus: null
        ,  options1:[
            {label:'Abierto',value:2},
            {label:'Cerrado',value:1},
          ]
        , colClass: "vx-col md:w-1/2 sm:w-full w-full mb-3"
      

      }
    },
    methods: {
      getFeedbacks(){
        if(this.loading === false){
          this.loading = true;
          axios.post( '/api/feedbacks', {
            'feedback_types': this.selected_feedback_types,
            'apps': this.selected_apps,
            'from': this.from,
            'to': this.to
          }).then(response => {
            this.loading = false;
            this.suppliers = response.data.suppliers;
            this.investors = response.data.investors;
            this.applicants = response.data.applicants;
            this.portal = response.data.portal;
            this.feedbacks = response.data.data;
            this.average = response.data.average;
          });
        }
      },
      getText(text){
        switch(text){
          case 'general_feedback': return 'Feedback General';
          case 'feature_request': return 'Solicitud de Funcionalidad';
          case 'service_issue': return 'Problema de Servicio';
          case 'suppliers': return 'Proveedores';
          case 'investors': return 'Inversionistas';
          case 'applicants': return 'Solicitantes';
          case 'portal': return 'Portal';
        }
      },
      getColor(cant){
        if(cant >= 8) return 'green';
        if(cant >= 5) return 'orange';
        return 'red'
      },
      formatPrice(value,decimales=0) {
        let val = (value/1).toFixed(decimales).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      async sendEmail(){
        if(this.comment != ""){
          this.showLoading(true);
          await axios.post('/api/feedbacks/sendFeedbackMail', {
            'feedback_id': this.feedbackId
            ,'comment': this.comment
            ,'email': this.user.user
          })
          .then(response => {
            this.getFeedbacks();
            this.showLoading(false);
            this.successNotif("Correo envíado con éxito", "Hemos enviado tu respuesta a nuestro cliente como seguimiento a su comentario.");
            this.cleanFields();
          })
          .catch(error => {
            this.showLoading(false);
            this.errorNotif("Algo salió mal", "No hemos podido llevar a cabo la tarea, comunicate con el área de soporte.");
          });
        } else {
          this.errorNotif("Sin mensaje", "Asegurate de escribir un mensaje antes de enviarlo.");
        }
      },
      openEmailPopUp(isEdit, data) {
        if(isEdit && data.email_response_by == null) {
          this.comment = null;
          this.feedbackId = data.id;
          this.uid = data.user_id;
          this.email = null;
          this.emailDate = null;
        } else {
          this.comment = data.email_response;
          this.feedbackId = data.id;
          this.uid = data.user_id;
          this.email = data.email_response_by;
          this.emailDate = data.email_response_date;
        }
          this.isEdit = isEdit;
          this.emailPopUp = true;
      },
      cleanFields(){
        this.emailPopUp = false;
        this.actionPopUp = false;
        this.isEdit = false;
        this.comment = null;
        this.feedbackId = null;
        this.uid = null;
        this.email = null;
        this.emailDate = null;
        this.feedbackStatus = null
      },
      handleOnClose(){
        this.cleanFields();
      },
      openActionsPopUp(tr){
        this.actionPopUp = true;
        this.feedbackId = tr.id;
        this.currentStatus = tr.status;
      },
      async updateFeedbackStatus(){
        if(this.feedbackStatus != null){
          this.showLoading(true);
          await axios.put('/api/feedbacks/updateFeedback', {
            'feedback_id': this.feedbackId
            ,'feedback_status': this.feedbackStatus
          })
          .then(response => {
            this.getFeedbacks();
            this.showLoading(false);
            this.successNotif("Acción actualizada con éxito", "Se ha actualizado la acción del comentario de manera exitosa.");
            this.cleanFields();
          })
          .catch(error => {
            this.showLoading(false);
            this.errorNotif("Algo salió mal", "No hemos podido llevar a cabo la tarea, comunicate con el área de soporte.");
          });
        } else {
          this.errorNotif("Sin acción", "Asegurate de elegir una acción.");
        }
      },
    },
    computed: {
      
    }
}
</script>

<style scoped>
  .custom-font {
      font-family: 'Poppins', sans-serif !important;
    }

  p span {
    color: #ff9800 !important;
  }
</style>
